module.exports = __webpack_public_path__ + "img/arrow-right-circle-white.7b2e8455.svg";